export default "/images/vendor/flag-icon-css/flags/1x1/gr.svg?c51a52c416ea428fe41f7cee240d7640";